















import {Component, Prop} from 'vue-property-decorator'
import Utils from '../../utils'
import ConfirmDialogCallback from '../../views/ConfirmDialogCallback.vue'
import Dropzone from '../../lib/dropzone/Dropzone.vue'
import {Attachment} from '@/lib/kepler/interfaces'
import {Action} from 'vuex-class'

@Component({
  components: {
    Dropzone,
    Button: Utils.loadComponent('Button'),
    Card: Utils.loadComponent('proxy/Card/Card'),
    Btn: Utils.loadComponent('proxy/Btn'),
    Container: Utils.loadComponent('proxy/Container'),
    TextField: Utils.loadComponent('proxy/Inputs/TextField'),
  },
  name: 'UpdateProfileImageDialog',
})
export default class UpdateProfileImageDialog extends ConfirmDialogCallback {
  @Action('closeDialog') public closeDialog: any
  @Prop() protected uploadCallback!: (response: Attachment) => void

  protected response: Attachment = {
    token: '',
    mime: '',
    url: '',
  }
  protected lang: object = {
    dictDefaultMessage: `<br>${this.$t('profile.set_your_profile_image')}`,
  }

  protected uploaded(file: any, response: any) {
    this.response.token = response.token
    this.response.url = file.dataURL
  }

  protected saveImage() {
    this.uploadCallback(this.response)
    this.closeDialog()
  }
}
